import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import Loading from '../loading.js'


class Photo extends React.Component{
  constructor(props){
    super(props)
    this.state={
      loading:true
    }
  }
  componentDidMount() {
    let image = new Image()
    image.src = this.props.src
    image.onload = (() => {
      this.setState({loading: false});
    })
  }
  render(){
    return (
        <div className={cn(css.media_container, css.photo_container)}>
          {!this.state.loading && <img alt="Story" src={this.props.src}/>}
          {this.state.loading && <Loading/>}
      </div>
    );
  }
}

export default Photo;



// WEBPACK FOOTER //
// ./src/components/account_page/story_details/media/photo.js